import React from 'react';

// Label-printer loading spinner: a Zebra ZD421-style printer that
// feeds out a label (barcode + skeleton content) on every "tick".
const PrinterSpinner = ({ label = 'Loading' }) => {
    return (
        <div className="flex flex-col items-center justify-center mt-10 space-y-4">
            <style>{`
                @keyframes printerLabelFeed {
                    0% { transform: translateY(-8px); opacity: 0; }
                    12% { opacity: 1; }
                    70% { transform: translateY(52px); opacity: 1; }
                    100% { transform: translateY(58px); opacity: 0; }
                }
                @keyframes printerStatusLight {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.25; }
                }
            `}</style>

            <div className="relative" style={{ width: 108, height: 100 }} role="status">
                <span className="sr-only">Loading...</span>

                {/* body */}
                <div
                    className="absolute rounded-b bg-gray-400 dark:bg-gray-700 border border-gray-500 dark:border-gray-800"
                    style={{ top: 14, left: 6, width: 96, height: 40, borderRadius: '6px 6px 4px 4px', boxShadow: '0 4px 10px rgba(0,0,0,0.15)' }}
                ></div>

                {/* lid (raised) */}
                <div
                    className="absolute bg-gray-300 dark:bg-gray-600 border border-gray-500 dark:border-gray-800"
                    style={{ top: -2.6, left: 14, width: 80, height: 19.2, borderRadius: '8px 8px 3px 3px' }}
                ></div>

                {/* smoke-tinted window over the roll */}
                <div
                    className="absolute overflow-hidden rounded"
                    style={{ top: 1, left: 24, width: 60, height: 11, background: 'rgba(20,22,24,0.35)', border: '1px solid rgba(0,0,0,0.25)' }}
                >
                    <div
                        className="absolute"
                        style={{ top: -4, left: 6, width: 14, height: 24, background: 'rgba(255,255,255,0.25)', transform: 'rotate(20deg)' }}
                    ></div>
                </div>

                {/* top button */}
                <div
                    className="absolute rounded-full bg-gray-500 dark:bg-gray-800 border border-gray-600 dark:border-gray-900"
                    style={{ top: -8.6, left: 48, width: 12, height: 12, boxShadow: 'inset 0 -1px 2px rgba(0,0,0,0.25)' }}
                ></div>

                {/* feed slot */}
                <div className="absolute bg-gray-800 dark:bg-gray-900 rounded" style={{ top: 38, left: 22, width: 64, height: 5 }}></div>

                {/* status light */}
                <div
                    className="absolute rounded-full bg-green-400"
                    style={{ top: 20, right: 16, width: 6, height: 6, animation: 'printerStatusLight 1.1s ease-in-out infinite' }}
                ></div>

                {/* wordmark */}
                <div className="absolute text-gray-600 dark:text-gray-400" style={{ top: 20, left: 16, fontSize: 6, fontWeight: 700, letterSpacing: '0.04em' }}>
                    Cloudlabel
                </div>

                {/* ejected label: barcode + skeleton content */}
                <div
                    className="absolute bg-white dark:bg-gray-100 border border-gray-300 rounded-sm"
                    style={{ top: 42, left: 24, width: 60, height: 34, padding: 4, boxSizing: 'border-box', animation: 'printerLabelFeed 1.8s ease-in infinite' }}
                >
                    <div className="flex mb-1" style={{ gap: 1, height: 11 }}>
                        {[1, 2, 1, 1, 2, 1, 1, 2, 1, 1, 2, 1].map((w, i) => (
                            <div key={i} style={{ width: w, background: '#2d3748' }}></div>
                        ))}
                    </div>
                    <div className="flex items-center" style={{ gap: 4 }}>
                        <div className="bg-gray-200 rounded-sm flex-shrink-0" style={{ width: 8, height: 8 }}></div>
                        <div className="flex flex-col flex-1" style={{ gap: 2 }}>
                            <div className="bg-gray-200 rounded-sm" style={{ height: 2, width: '90%' }}></div>
                            <div className="bg-gray-200 rounded-sm" style={{ height: 2, width: '60%' }}></div>
                        </div>
                    </div>
                </div>
            </div>

            <span className="text-sm text-gray-500 dark:text-gray-400">{label}</span>
        </div>
    );
};

export default PrinterSpinner;
